import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { OthersService } from '../others/othersDataService';
import { CompetenciesService } from '../competencies.service';
import { SidebarModel } from 'src/app/Models/OthersWidgetModel';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';

@Component({
  selector: 'app-sub-competencies-sidebar',
  templateUrl: './sub-competencies-sidebar.component.html',
  styleUrls: ['./sub-competencies-sidebar.component.css']
})
export class SubCompetenciesSidebarComponent implements OnInit {
  [x: string]: any;

  constructor(private route: ActivatedRoute, private router: Router,
    private service: SkillRepoEmployeesService, private othersService: OthersService, private competencyService: CompetenciesService,) { }

  @Output() serviceAreaLevelCount = new EventEmitter<any>();
  @Output() competencyLevelCount = new EventEmitter<any>();


  competencyId: number;
  competencyName: string = '';
  tabs: SidebarModel[] = [];
  selectedTab: any;
  subCompetencyId: number;
  compId: number;
  selectedTabName: string;

  ngOnInit() {
    this.competencyService.profileStatus$.subscribe(value => {
      this.competencyId = value;
      if (this.competencyId == null) {
        this.competencyId = Number(sessionStorage.getItem("compId"))
      }
      this.getSubCompetencies(this.competencyId);
      this.GetServiceAreaLevelCounts();
    })


    this.competencyService.competencyName$.subscribe(value => {
      this.competencyName = value
      if (this.competencyName == null || this.competencyName == "") {
        this.competencyName = sessionStorage.getItem("compTitle")
      }
    })
    this.othersService.name$.subscribe(value => {
      if (value != '') {
        this.selectedTab = value
        this.selectedTabName = value;
      }
      if (this.selectedTab == null) {
        this.selectedTab = Number(sessionStorage.getItem("SubcompId"))

      }
      if (this.selectedTabName == null) {
        this.selectedTabName = (sessionStorage.getItem("SubcompTitle"))

      }
    })
    this.getCompetencyLevelCounts();
  }

  serviceLevelSkillData: any
  GetServiceAreaLevelCounts() {
    this.competencyService.GetServiceAreaLevelCounts(this.competencyId).subscribe(res => {
      this.serviceLevelSkillData = res.data;
      this.othersService.id$.subscribe(value => {
        this.subCompetencyId = value;
      })
      if (this.subCompetencyId == null || this.subCompetencyId == undefined) {
        for (let i of this.serviceLevelSkillData) {
          this.serviceAreaLevelCount.emit(i.areaCountList);
          break;
        }
      }
      else {
        for (let i of this.serviceLevelSkillData) {
          if (this.subCompetencyId == i.subCompetencyId) {
            this.serviceAreaLevelCount.emit(i.areaCountList);
            break;
          }
        }
      }
    })
  }

  competencyLevelSkillData: any;

  getCompetencyLevelCounts() {
    this.competencyService.GetCompetencyLevelCounts(this.competencyId).subscribe(res => {
      if (res.data && res.data.length > 0) {
        this.competencyLevelSkillData = res.data;
      }
      else {
        const dummyData = this.dummydata.find(item => item.CompetencyId === this.competencyId);
        if (dummyData) {
          this.competencyLevelSkillData = dummyData.areaCountList;
        } else {
          this.competencyLevelSkillData = [];
        }
      }
      this.competencyLevelCount.emit(this.competencyLevelSkillData);
    });
  }


  skillData: any;

  subcompname: any;
  selectTab(tab: SidebarModel): void {

    this.selectedTab = tab.name;
    this.selectedTabName = this.selectedTab
    this.subCompetencyId = Number(tab.id);
    this.othersService.updateId(tab.id);
    this.othersService.updateName(tab.name)
    sessionStorage.setItem("SubcompTitle", tab.name);
    sessionStorage.setItem("SubcompId", tab.id);
    let subCompetency = this.serviceLevelSkillData.find(item => item.subCompetencyId === this.subCompetencyId);
    if (!subCompetency) {
      const dummySubCompetency = this.dummydata.find(item => item.CompetencyId === this.competencyId.toString());
      if (dummySubCompetency) {
        subCompetency = {
          subCompetencyId: dummySubCompetency.CompetencyId,
          subCompetencyName: dummySubCompetency.subCompetencyName,
          areaCountList: dummySubCompetency.areaCountList
        };
      }
    }
    if (subCompetency) {
      this.skillData = subCompetency.areaCountList;
    } else {
      this.skillData = [];
    }
    this.serviceAreaLevelCount.emit(this.skillData);
    this.competencyName = this.competencyName.split(' ').join('')
    this.selectedTab = this.selectedTab.replace(/\//g, '');
    this.selectedTab = this.selectedTab.split(' ').join('')

    this.router.resetConfig(this.router.config); /*this line will clear*/

    this.router.navigate([`Home/Competencies/${this.competencyName}/${this.selectedTab}`])
  }

  getSubCompetencies(competencyId: number) {

    this.competencyService.getSubCompetenciesForDropDowns(competencyId).subscribe(res => {
      //console.log('res', res);
      
      this.tabs = res.data;
      if (this.subCompetencyId == -1 || this.selectedTab == '' || this.selectedTab == undefined) {
        this.selectedTab = this.tabs[0].name;
        this.subCompetencyId = Number(this.tabs[0].id)
        this.othersService.updateId(this.subCompetencyId);
        this.othersService.updateName(this.selectedTab)
        sessionStorage.setItem("SubcompTitle", this.selectedTab);
        sessionStorage.setItem("SubcompId", this.tabs[0].id);
        this.selectedTabName = this.tabs[0].name;
      }

    })
  }
}
